import React from "react";
import { OnlineFormCertificateContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { ROUTE_PATH } from "utils/constants/routePath";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import { Buttons, Displays, Forms, Headers, Icons } from "components";

/**
 * หน้ารับ Certificate ของ Online Form — เข้าจากการสแกน QR ของ "ใบ" ใบใดใบหนึ่ง
 *
 * 1 online form มีได้หลายใบ (เช่น กลอง/กีตาร์/เบส) แอดมินเป็นคนเลือกว่าจะเปิด
 * QR ใบไหนให้นักเรียนคนไหนสแกน ระบบไม่ตรวจว่า "ควร" ได้ใบไหน ตามที่ตกลงในเฟสนี้
 *
 * QR คือทางเข้าทางเดียว — ถ้าปิดแอปกลางทางให้สแกนใหม่ เพราะแอปไม่มีทางรู้เองว่า
 * นักเรียนคนนี้ควรได้ใบไหนจากทั้งหมดที่ผูกกับฟอร์ม
 */
class OnlineFormCertificateContainer extends React.Component {
  _isSubmitting = false;

  state = {
    isLoading: true,
    step: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { authenRedux, router, t } = this.props;
    const certificateId = router.params?.id;

    let res = await userService.GET_ONLINE_FORM_CERTIFICATE_INFO(
      certificateId,
      authenRedux.member_type_active,
    );

    if (!res || res.status !== 200) {
      this.setState({ isLoading: false });
      toast.error(
        res?.data?.error?.code === "CERTIFICATE_EXPIRED"
          ? t("Certificate expired", { ns: "common" })
          : t("Certificate not available", { ns: "common" }),
      );
      this.handleGoHome();
      return;
    }

    const info = res.data;
    if (!info.is_eligible) {
      this.setState({ isLoading: false });
      toast.error(t("Online form not passed", { ns: "common" }));
      this.handleGoHome();
      return;
    }

    if (info.is_already_issued) {
      this.setState({
        info,
        generateHistoryId: info.certificate_generate_history_id,
        isLoading: false,
        step: 3,
      });
      return;
    }

    this.setState({
      info,
      initialValues: {
        first_name: authenRedux.first_name || "",
        last_name: authenRedux.last_name || "",
        email: authenRedux.email || "",
      },
      isLoading: false,
      step: 1,
    });
  };

  handleSubmitForm = (values) => {
    this.setState({ formValues: values, step: 2 });
  };

  handleBackToEdit = () => {
    const { formValues } = this.state;
    this.setState({ initialValues: formValues, step: 1 });
  };

  handleConfirm = async () => {
    const { router, t, authenRedux } = this.props;
    const { formValues } = this.state;
    if (this._isSubmitting) return;
    this._isSubmitting = true;
    this.setState({ isBgLoading: true });

    let res = await userService.POST_ONLINE_FORM_CERTIFICATE({
      certificate_id: router.params?.id,
      first_name: formValues.first_name,
      last_name: formValues.last_name,
      email: formValues.email,
      member_type: authenRedux.member_type_active,
    });

    this._isSubmitting = false;
    if (res && res.status === 200) {
      this.setState({
        isBgLoading: false,
        generateHistoryId: res.data?.certificate_generate_history_id,
        step: 3,
      });
    } else {
      this.setState({ isBgLoading: false });
      toast.error(
        res?.data?.error?.code === "CERTIFICATE_EXPIRED"
          ? t("Certificate expired", { ns: "common" })
          : res?.data?.error?.message ||
              t("Certificate request failed", { ns: "common" }),
      );
    }
  };

  handleGoHome = () => {
    this.props.router.navigate(ROUTE_PATH.HOME);
  };

  handleDownloadNow = () => {
    const { generateHistoryId } = this.state;
    if (generateHistoryId) {
      this.props.router.navigate(
        `${ROUTE_PATH.CERIFICATE}/${generateHistoryId}`,
      );
    }
  };

  render() {
    const { t } = this.props;
    const {
      isLoading,
      isBgLoading,
      step,
      info,
      initialValues,
      formValues,
      generateHistoryId,
    } = this.state;

    return (
      <OnlineFormCertificateContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="certificate_container">
          <Headers.NewPageHeader
            title={"CERTIFICATE"}
            sub_title={"ประกาศนียบัตร"}
          />
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              {info && step !== 3 && (
                <div className="cert_info_box">
                  <div className="ci_name">{info.certificate_name}</div>
                  {info.activity_name && (
                    <div className="ci_activity">{info.activity_name}</div>
                  )}
                </div>
              )}

              {step === 1 && (
                <>
                  <div className="step_desc">
                    {t(
                      "Thank you for participating in the activity. Please check your name and email so we can send your certificate.",
                      { ns: "common" },
                    )}
                  </div>
                  <Forms.ActivityCertificateForm
                    initialValues={initialValues}
                    onSubmit={this.handleSubmitForm}
                  />
                </>
              )}

              {step === 2 && (
                <>
                  <div className="step_title">
                    {t("Confirm your information", { ns: "common" })}
                  </div>
                  <div className="confirm_box">
                    <div className="cb_item">
                      <div className="cb_label">
                        {t("First name", { ns: "common" })}
                      </div>
                      <div className="cb_value">{formValues?.first_name}</div>
                    </div>
                    <div className="cb_item">
                      <div className="cb_label">
                        {t("Last name", { ns: "common" })}
                      </div>
                      <div className="cb_value">{formValues?.last_name}</div>
                    </div>
                    <div className="cb_item">
                      <div className="cb_label">
                        {t("Email (for receiving image files)", {
                          ns: "common",
                        })}
                      </div>
                      <div className="cb_value">{formValues?.email}</div>
                    </div>
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Confirm", { ns: "common" })}
                      onClick={this.handleConfirm}
                    />
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      theme_gray
                      label={t("Edit", { ns: "common" })}
                      onClick={this.handleBackToEdit}
                    />
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <div className="result_section">
                    <div className="result_icon">
                      <Icons.Success width={80} height={80} />
                    </div>
                    <div className="result_title">
                      {t("Confirmation successful", { ns: "common" })}
                    </div>
                    <div className="result_sub_title">
                      {t(
                        "We will send your certificate to the email you provided.",
                        { ns: "common" },
                      )}
                    </div>
                  </div>
                  <div className="btn_wrap">
                    <Buttons.BgStandard
                      label={t("Home", { ns: "common" })}
                      onClick={this.handleGoHome}
                    />
                  </div>
                  {generateHistoryId && (
                    <div className="btn_wrap">
                      <Buttons.BgStandard
                        theme_gray
                        label={t("Download now", { ns: "common" })}
                        onClick={this.handleDownloadNow}
                      />
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </OnlineFormCertificateContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation(["common"])(withRouter(OnlineFormCertificateContainer)));
